import { gql } from '@apollo/client';
import React from 'react';
import AvatarWithAction from '../components/AvatarWithAction';
import MetaList, { MetaListItem } from '../components/MetaList';
import Timestamp from '../components/Timestamp';
import type { Activity_ActorFragment } from '../graphql/generated/graphqlTypes';
import styles from './Activity.module.scss';

const ACTIVITY_ACTOR = gql`
  fragment Activity_actor on User {
    id
    ...AvatarWithAction_user
  }
  ${AvatarWithAction.fragments.user}
`;

interface ActivityProps {
  actor: Activity_ActorFragment;
  action:
    | 'POST_EDIT'
    | 'COMMENT_CREATE'
    | 'COMMENT_REPLY'
    | 'POST_THANK'
    | 'POST_PUBLISH'
    | 'INVITE_ACCEPT';
  actedAt: number | string;
  title: React.ReactNode;
  meta?: string | null;
  metaRight?: React.ReactNode;
  children?: React.ReactNode;
}

const Activity = ({
  actor,
  action,
  actedAt,
  title,
  meta,
  metaRight,
  children,
}: ActivityProps) => (
  <div className={styles.activity}>
    <div className={styles.timeline}>
      <AvatarWithAction user={actor} action={action} />
      <div className={styles.line} />
    </div>
    <div className={styles.content}>
      <div className={styles.title}>{title}</div>
      {!!children && <div className={styles.contentWrapper}>{children}</div>}
      <div className={styles.meta}>
        <MetaList>
          <MetaListItem>
            <div className={styles.timestamp}>
              <Timestamp date={actedAt} />
            </div>
          </MetaListItem>
          {meta && <MetaListItem>{meta}</MetaListItem>}
        </MetaList>
        {!!metaRight && <div className={styles.metaRight}>{metaRight}</div>}
      </div>
    </div>
  </div>
);

Activity.fragments = { actor: ACTIVITY_ACTOR };

export default Activity;
